import React from "react";
import { useTheme } from "@mui/styles";
import { Typography, useMediaQuery, Box } from "@mui/material";
import HomeMiscelaneaBackground from "../../img/HomeMiscelaneaBackground.png";
import LaborInsertionCard from "./LaborInsertionCard";
import { useLocation } from "react-router-dom";
import useTranslation from "../../hooks/useTranslation";

const useStyles = (theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  child: {
    display: "flex",
    width: "100vw",
    backgroundImage: `url(${HomeMiscelaneaBackground})`,
    height: "8rem",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "right",
    justifyContent: "center",
    alignItems: "flex-end",
    marginBottom: "21px",
  },
  title: {
    color: theme.palette.red.main,
    fontWeight: "600",
    letterSpacing: { xs: "1.4px", md: "1.6px" },
    fontSize: { xs: "14px", md: "16px" },
  },
  subtitle: {
    color: theme.palette.blue.main,
    fontFamily: theme.typography.montserrat.bold,
    fontSize: { xs: "32px", md: "54px", lg: "65px" },
    lineHeight: { xs: "33px", md: "63px", lg: "79px" },
    mb: { xs: "21px", md: "23px" },
  },
  laborInsertion: {
    maxWidth: { xs: "271px", md: "834px" },
    fontFamily: theme.typography.anaHeim.regular,
    color: theme.palette.blue.main,
    fontSize: { xs: "20px", md: "24px", lg: "26px" },
    lineHeight: { xs: "29px", md: "33.6px", lg: "36px" },
    textAlign: "center",
    mb: { xs: "75px", md: "4rem" },
  },
  cardsContainer: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: { xs: "center", md: "space-between" },
    alignItems: { xs: "baseline" },
    width: { xs: "100vw", md: "850px", lg: "1200px", xl: "1400px" },
  },
  line: {
    width: "25px",
    border: `1px solid ${theme.palette.red.main}`,
    marginRight: "8px",
    height: 0,
    backgroundColor: theme.palette.red.main,
  },
  lineBox: {
    display: "flex",
    height: "21px",
    justifyContent: "center",
    alignItems: "center",
  },
});

const LaborInsertion = (props) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const isMobile = useMediaQuery("(max-width:899px)");
  const { pathname } = useLocation();
  const { title, subtitle, laborInsertion, jobPlacement } = useTranslation(
    pathname,
    "LaborInsertion"
  );

  return (
    <div style={classes.container} ref={props.innerRef}>
      <div style={classes.child}>
        {isMobile ? null : (
          <Box sx={classes.lineBox}>
            <div style={classes.line}></div>
          </Box>
        )}
        <Typography sx={classes.title}>{title}</Typography>
      </div>

      <Typography sx={classes.subtitle}>{subtitle}</Typography>

      <Typography sx={classes.laborInsertion}>
        {laborInsertion[0]}
        <b>{laborInsertion[1]}</b>
        {laborInsertion[2]}
      </Typography>

      <Box sx={classes.cardsContainer}>
        {jobPlacement.map((item, index) => {
          const styles = {
            maxWidth: [
              { xs: "161px", md: "inherit", lg: "290px" },
              { xs: "107.3px", md: "inherit", lg: "167px" },
              { xs: "158px", md: "inherit", lg: "231px" },
              { xs: "124px", md: "inherit", lg: "205px" },
              { xs: "167px", md: "inherit", lg: "282px" },
            ],
            marginBottom: ["75px", "75px", "75px", { xs: "31px", md: "75px" }],
          };
          const { img, text } = item;
          return (
            <LaborInsertionCard
              key={text}
              index={index}
              img={img}
              text={text}
              maxWidth={styles.maxWidth[index]}
              marginBottom={styles.marginBottom[index]}
            />
          );
        })}
      </Box>
    </div>
  );
};

export default LaborInsertion;
